"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const xstate_1 = require("xstate");
const react_2 = require("@xstate/react");
const States_1 = require("../../lib/constants/States");
const Actions_1 = require("../../lib/constants/Actions");
const messages_1 = __importDefault(require("../../lib/messages"));
const utils_1 = require("../../lib/utils");
const styles_1 = require("./styles");
function ProxyBookingControls({ service, intl }) {
    const [state, send] = (0, react_2.useService)(service);
    const { ehrPatientList, selectedPatientIndex } = state.context;
    const patientNames = (0, react_1.useMemo)(() => {
        const proxySelectList = ehrPatientList.map((patient, index) => {
            return {
                value: index,
                text: patient.name
            };
        });
        proxySelectList.push({
            value: null,
            text: intl.formatMessage(messages_1.default.proxyBookingSomeoneElse)
        });
        return proxySelectList;
    }, [ehrPatientList, intl]);
    const getSelectedItem = react_1.default.useCallback((selectedPatientIndex) => {
        if (selectedPatientIndex === undefined || selectedPatientIndex === null) {
            // Return the 'Someone Else' item
            return patientNames[patientNames.length - 1];
        }
        return patientNames[selectedPatientIndex];
    }, [patientNames]);
    const itemToString = (item) => (item ? item.text : '');
    const shouldShowProxyBookingDropdown = !state.matches(`${States_1.ehrData}.${States_1.ehrFormNoDropdown}`);
    const urlParams = new URLSearchParams(window.location.search);
    const isCernerEmbedded = urlParams.get('from') === 'cerner_embedded_order_appts';
    if (isCernerEmbedded) {
        return null;
    }
    return (react_1.default.createElement("div", { "data-testid": "EhrProxyBookingControls" }, !state.matches(`${States_1.ehrData}.${States_1.ehrMainFailed}`) &&
        shouldShowProxyBookingDropdown ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Header, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.proxyBookingControlsHeader))),
        react_1.default.createElement(styles_1.ProxySelect, { "data-testid": "EhrPatientSelect", items: patientNames, itemToString: itemToString, icon: 'ArrowDown', selectedItem: getSelectedItem(selectedPatientIndex), disabled: state.matches(States_1.pendingEhrPatientDemographics), onSelect: (item) => {
                send({
                    type: Actions_1.SELECT_PATIENT,
                    data: {
                        patientIndex: item.value
                    }
                });
            } }),
        state.matches(`${States_1.ehrData}.${States_1.ehrSubFailed}`) && (react_1.default.createElement(styles_1.InfoBanner, { "data-testid": "EhrSubPatientLoadError" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.subPatientDemographicLoadError)))),
        (0, utils_1.relatedFailedStateMatchHelper)(state) && (react_1.default.createElement(styles_1.WarningBanner, { "data-testid": "EhrRelatedPatientLoadError" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.relatedPatientDemographicLoadError)))))) : state.matches(`${States_1.ehrData}.${States_1.ehrMainFailed}`) ? (react_1.default.createElement(styles_1.InfoBanner, { "data-testid": "EhrMainPatientLoadError" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.mainPatientDemographicLoadError)))) : null));
}
ProxyBookingControls.propTypes = {
    service: (0, prop_types_1.instanceOf)(xstate_1.Interpreter).isRequired,
    loginProps: (0, prop_types_1.shape)({
        showProxyBookingControls: prop_types_1.bool
    }),
    // supplied via `injectIntl`
    intl: (0, prop_types_1.shape)({
        formatMessage: prop_types_1.func.isRequired
    })
};
exports.default = (0, intl_1.injectIntl)(ProxyBookingControls);
//# sourceMappingURL=ProxyBookingControls.js.map